export const AssessmentSubType = {
    RATING_1To5: 5,
    RATING_1To10: 6,
    GUIDEDSCALE: 7,
    LIKERT: 8
};
